import React from "react";
import round from "lodash/round";

import { Meet } from "types";
import { Column } from "components/table/Table";
import { wilksCoef } from "util/formulas/wilks";

const WilksCoefCell = ({
  data,
  column,
  meet,
  style,
}: {
  data: any;
  column: Column;
  meet: Meet;
  style: React.CSSProperties;
}) => {
  const lifter = data;
  if (lifter.row === "header") {
    return (
      <div style={style} className="table-cell-inner">
        {column.label}
      </div>
    );
  } else {
    const wilksCoefNumber = wilksCoef(lifter, meet);
    return (
      <div style={style} className="table-cell-inner">
        {!!wilksCoefNumber && round(wilksCoefNumber, 4)}
      </div>
    );
  }
};

export default WilksCoefCell;
